'use strict';

var _ = require('lodash');
var StrategyActionController = function StrategyActionController($scope, strategyRecordService, strategyActionDataService, CommonUiConstants, StrategyConstants) {
  $scope.selectAction = function () {
    $scope.changeSelectedRow($scope.action, 'actions');
  };
  var selectedCategory = $scope.action.category;
  var selectedCriterion = $scope.action.criterion;
  var selectedAction = $scope.action.action;
  var actionName = StrategyConstants.ACTION;
  $scope.categories = strategyRecordService.getCategories(actionName, $scope.level, $scope.activeEntityType);
  $scope.criteria = strategyRecordService.getCriteria(actionName, $scope.level, $scope.activeEntityType, undefined, selectedCategory);
  $scope.actions = strategyRecordService.getActions(actionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion);
  $scope.constraint = strategyRecordService.getConstraint(actionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion);
  $scope.valueType = strategyRecordService.getValueType(actionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion, selectedAction);
  $scope.pattern = strategyRecordService.getPattern(actionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion, selectedAction);
  $scope.constraintErrorMessage = $scope.constraint && $scope.constraint.message;
  function fillOperandData() {
    if (_.isArray($scope.action.field)) {
      $scope.valueData = _.reduce($scope.action.field, function (result, field, idx) {
        result[idx] = strategyActionDataService.getOperandData(field);
        return result;
      }, []);
    } else {
      $scope.valueData = strategyActionDataService.getOperandData($scope.action.field);
    }
  }
  function fillCriteriaTypeDefault() {
    if (_.isEmpty($scope.action.criteriaType)) {
      $scope.action.criteriaType = strategyRecordService.getValueForCriteriaType(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
    }
  }
  fillOperandData();
  fillCriteriaTypeDefault();
  $scope.POSITIVE_INT_PATTERN = CommonUiConstants.POSITIVE_INT_PATTERN;
  $scope.FLOAT_PATTERN = CommonUiConstants.FLOAT_PATTERN;
  $scope.FLOAT_PERSISTENCE_2_PATTERN = CommonUiConstants.FLOAT_PERSISTENCE_2_PATTERN;
  $scope.POSITIVE_FLOAT_PERSISTENCE_2_PATTERN = CommonUiConstants.POSITIVE_FLOAT_PERSISTENCE_2_PATTERN;
  $scope.STRATEGY_ACTION_CLASS_LINK_VALUE_PATTERN = CommonUiConstants.STRATEGY_ACTION_CLASS_LINK_VALUE_PATTERN;
  $scope.MIN_RTP = 0;
  $scope.MAX_RTP = 400;
  $scope.classLinkMsg = require('../templates/class-link-validation.html');
  $scope.validationMessage = 'Invalid entry';
  $scope.positiveNumberWarning = 'The value must be a positive number';
  $scope.numberWarning = 'The value must be a number';
  $scope.maxSmallerThanMinWarning = 'Max value cannot be smaller than min value';
  $scope.minBiggerThanMaxWarning = 'Min value cannot be bigger than max value';
  $scope.startSmallerThanEndWarning = 'Start RTP value cannot be smaller than end RTP value';
  $scope.endBiggerThanStartWarning = 'End RTP value cannot be bigger than start RTP value';
  $scope.startRtpTooBig = 'RTP value cannot be bigger than ' + $scope.MAX_RTP;
  $scope.endRtpTooLow = 'RTP value cannot be smaller than ' + $scope.MIN_RTP;
  function clearModel(withAction, withCriteria) {
    $scope.action.value = null;
    $scope.action.secondValue = null;
    $scope.action.thirdValue = null;
    $scope.action.field = null;
    $scope.action.level = null;
    $scope.action.criteriaType = null;
    $scope.action.argsNo = null;
    if (withCriteria) {
      $scope.action.criterion = null;
    }
    if (withAction) {
      $scope.action.action = null;
    }
  }
  $scope.onCategoryChange = function () {
    $scope.criteria = strategyRecordService.getCriteria(actionName, $scope.level, $scope.activeEntityType, undefined, $scope.action.category);
    $scope.actions = null;
    $scope.constraint = null;
    clearModel(true, true);
  };
  $scope.onCriteriaChange = function () {
    $scope.actions = strategyRecordService.getActions(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
    $scope.field = strategyRecordService.getField(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
    $scope.constraint = strategyRecordService.getConstraint(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
    $scope.constraintErrorMessage = $scope.constraint && $scope.constraint.message;
    clearModel(true);
    if ($scope.actions.length > 0) {
      $scope.action.action = $scope.actions[0];
      $scope.onActionChange();
    }
    $scope.action.field = $scope.field;
  };
  function handleClassLinkValueType() {
    if ($scope.action.category === 'Class Link' && $scope.action.action !== 'Remove') {
      $scope.valueType = 'classLinkText';
    }
    return $scope.valueType;
  }
  handleClassLinkValueType();
  $scope.onActionChange = function () {
    $scope.valueType = strategyRecordService.getValueType(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion, $scope.action.action);
    $scope.pattern = strategyRecordService.getPattern(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion, $scope.action.action);
    $scope.argsNo = strategyRecordService.getArgsNo(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion, $scope.action.action);
    handleClassLinkValueType();
    $scope.field = strategyRecordService.getField(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
    $scope.constraint = strategyRecordService.getConstraint(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
    $scope.constraintErrorMessage = $scope.constraint && $scope.constraint.message;
    clearModel();
    $scope.action.field = $scope.field;
    $scope.action.argsNo = $scope.argsNo;
    $scope.action.level = $scope.level;
    fillCriteriaTypeDefault();
    fillOperandData();
  };
  $scope.hasVisibleCriteriaType = function () {
    return strategyRecordService.hasVisibleCriteriaType('action', $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion);
  };
  $scope.isSingleAction = function () {
    $scope.argsNo = strategyRecordService.getArgsNo(actionName, $scope.level, $scope.activeEntityType, $scope.action.category, $scope.action.criterion, $scope.action.action);
    return $scope.argsNo === '1' && !$scope.hasVisibleCriteriaType();
  };
};
StrategyActionController.$inject = ['$scope', 'StrategyRecordService', 'StrategyActionDataService', 'CommonUiConstants', 'StrategyConstants'];
module.exports = StrategyActionController;